import { Team } from 'entities';
import { TFunction } from 'i18next';

export type TeamFormData = Omit<Team, 'id'> & { id?: string };

export const groupRenders: Array<{
  property: keyof TeamFormData;
  getLabel: (t: TFunction) => string;
  values: { getLabel: (t: TFunction) => string; value: string | null }[];
}> = [
  {
    getLabel: (t: TFunction) => t('reprice-control'),
    property: 'reprice',
    values: [
      { value: 'AUTHORIZE', getLabel: (t: TFunction) => t('authorize') },
      { value: 'REQUEST', getLabel: (t: TFunction) => t('request-uppercase') },
      { value: null, getLabel: (t: TFunction) => t('no-uppercase') },
    ],
  },
  {
    getLabel: (t: TFunction) => t('outsourcing-control'),
    property: 'outsourcing',
    values: [
      { value: 'AUTHORIZE', getLabel: (t: TFunction) => t('authorize') },
      { value: 'REQUEST', getLabel: (t: TFunction) => t('request-uppercase') },
      { value: null, getLabel: (t: TFunction) => t('no-uppercase') },
    ],
  },
  {
    getLabel: (t: TFunction) => t('task-management'),
    property: 'taskManagement',
    values: [
      { value: 'ALL', getLabel: (t: TFunction) => t('everyone') },
      { value: 'TEAM_ONLY', getLabel: (t: TFunction) => t('team-only') },
      { value: null, getLabel: (t: TFunction) => t('no-uppercase') },
    ],
  },
  {
    getLabel: (t: TFunction) => t('add-task-subOwner'),
    property: 'addTaskSubOwner',
    values: [
      { value: 'ALL', getLabel: (t: TFunction) => t('everyone') },
      { value: 'MANAGERS_ONLY', getLabel: (t: TFunction) => t('managers-only') },
      { value: null, getLabel: (t: TFunction) => t('no-uppercase') },
    ],
  },
];

export const booleanRenders: {
  property: keyof TeamFormData;
  getLabel: (t: TFunction) => string;
}[] = [
  {
    property: 'hasServices',
    getLabel: (t: TFunction) => t('has-services'),
  },
  {
    property: 'salesArea',
    getLabel: (t: TFunction) => t('is-sales-area'),
  },
  {
    property: 'isInvoiceTeam',
    getLabel: (t: TFunction) => t('is-invoice-area'),
  },
  {
    property: 'isRecruitmentTeam',
    getLabel: (t: TFunction) => t('is-recruitment-area'),
  },
  {
    property: 'canAssumeTasksFromOtherAreas',
    getLabel: (t: TFunction) => t('can-assume-tasks-from-other-areas'),
  },
  {
    property: 'canAssumeProject',
    getLabel: (t: TFunction) => t('can-assume-project'),
  },
  {
    property: 'canRequestTaskReasignement',
    getLabel: (t: TFunction) => t('can-request-task-reasignment'),
  },
  {
    property: 'canSetDeadlines',
    getLabel: (t: TFunction) => t('can-set-deadlines'),
  },
  {
    property: 'canChangePrices',
    getLabel: (t: TFunction) => t('can-change-prices'),
  },
  {
    property: 'isProjectOwner',
    getLabel: (t: TFunction) => t('is-project-owner'),
  },
  {
    property: 'canCreateProject',
    getLabel: (t: TFunction) => t('can-create-project'),
  },
  // {
  //   property: 'canApproveDiscount',
  //   getLabel: (t: TFunction) => t('can-approve-discounts'),
  // },
  {
    property: 'canEnableProjectToStart',
    getLabel: (t: TFunction) => t('can-enable-project-to-start'),
  },
  {
    property: 'canApproveCountryAddition',
    getLabel: (t: TFunction) => t('can-approve-country-addition'),
  },
  {
    property: 'clientsPageAccess',
    getLabel: (t: TFunction) => t('client-page-access'),
  },
];
